/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SubscriptionsidcancelSubscription model module.
 * @module model/SubscriptionsidcancelSubscription
 * @version v0.3
 */
export default class SubscriptionsidcancelSubscription {
  /**
   * Constructs a new <code>SubscriptionsidcancelSubscription</code>.
   * @alias module:model/SubscriptionsidcancelSubscription
   * @class
   * @param patientId {String} ID of the Patient you want to create a subscription for
   */
  constructor(patientId) {
    this.patientId = patientId;
  }

  /**
   * Constructs a <code>SubscriptionsidcancelSubscription</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SubscriptionsidcancelSubscription} obj Optional instance to populate.
   * @return {module:model/SubscriptionsidcancelSubscription} The populated <code>SubscriptionsidcancelSubscription</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SubscriptionsidcancelSubscription();
      if (data.hasOwnProperty('patient_id'))
        obj.patientId = ApiClient.convertToType(data['patient_id'], 'String');
    }
    return obj;
  }
}

/**
 * ID of the Patient you want to create a subscription for
 * @member {String} patientId
 */
SubscriptionsidcancelSubscription.prototype.patientId = undefined;

